// House form-field wrapper — RON-5466.
//
// Reproduces the app's standard field markup exactly as the guest-invite form in CalendarEvent
// writes it: `.form-row` wrapper, `.popup-inner-title` label, `.form-control` input and an
// `.error-text` block with the shared error icon. Centralised so every visitor field stays
// consistent and the house class names live in one place.
//
// `.form-row` is doing more than spacing. `main-style.css` styles inputs only via
// `.form-row .form-control` (and `.new-booking-tab-inner .form-control`), and it sets the border
// with `!important` — which is the only thing defeating the global
// `.form-control:focus { border: unset }` a few rules earlier. A `.form-control` outside a
// `.form-row` therefore renders as bare Bootstrap and LOSES ITS BORDER ENTIRELY on focus, which
// is exactly how the wizard fields first looked.

import errorIcon from "../../../assets/images/icons/error-msg.svg";

// Input classes for a house field: red + error icon when invalid, green tick once filled in.
// Mirrors CalendarEvent's guest fields. `withTick` is off for time and date inputs, whose right
// edge is already occupied by the native picker button / the calendar `::after`.
export const fieldClassName = (value, error, withTick = true) => {
  const filled = String(value ?? "").trim().length > 0;

  return [
    "form-control",
    error ? "error-form" : "",
    withTick && !error && filled ? "success-validation" : "",
  ]
    .filter(Boolean)
    .join(" ");
};

// `required` draws the `*` RED, in its own span, rather than leaving it in the label string.
//
// Two conventions exist in the app: BookMeeting / NewMeetingModal / GuestModal concatenate a black
// `*` onto the label text, and Reception uses a coloured span (`.reception-field__req`). This
// module now follows Reception's — a black `*` sits in the same colour and weight as the word
// before it and reads as part of it.
//
// Placeholders keep the plain `*`: a placeholder is a string attribute and cannot carry a colour.
const VisitorFormRow = ({ id, label, required, error, hint, children }) => (
  <div className="form-row mb-3">
    <label className="popup-inner-title m-0" htmlFor={id}>
      {label}
      {/* Not `aria-hidden`: the `*` used to be part of the label string and was announced. Hiding
          it now would quietly drop that cue for screen readers rather than just recolour it. */}
      {required && <span className="visitor-field__req">*</span>}
    </label>

    {children}

    {hint && <p className="visitor-form-row__hint">{hint}</p>}

    {error && (
      <div className="error-text">
        <img src={errorIcon} alt="" />
        <p>{error}</p>
      </div>
    )}
  </div>
);

export default VisitorFormRow;
